<section class="content">
    <div *ngIf="autorisation ===null" class="text-center">
        <br/>
        <button type="button" [routerLink]="'/app/customers/new'" class="btn btn-primary btn-sm center-block"><i
                class="fa fa-plus-circle" aria-hidden="true"></i>
        </button>
    </div>

    <div class="container-fluid plandetail">
        <div class="row margin-left:10px;margin-bottom: 1px;">
            <div class="cap text-center">
                <span *ngIf="autorisation ===null"><h3>{{"CUSTOMER_LIST" | translate}}</h3></span>
                <span *ngIf="autorisation !==null"><h3>{{"CUSTOMER_LIST_TO_BE_CERTIFIED" | translate}}</h3></span>
            </div>
            <div class="row margin-left:5px; margin-bottom: 0px;">
                <div class="col-sm-10">&nbsp;</div>
                <div class="col-sm-2">
                    <select class="pull-right" style="width: 50px" (change)="onPageSizeChanged(+pagesize.value)"
                            #pagesize>
                        <option value="25">25</option>
                        <option value="100" selected="">100</option>
                        <option value="500">500</option>
                        <option value="1000">1000</option>
                    </select>
                    <label class="pull-right" style="font-weight: normal"><b>{{"SHOW" | translate}}&nbsp;&nbsp;</b></label>
                </div>
            </div>
        </div>
        <div class="row margin-left:10px;margin-top:1px;width:95%;margin-right:10px;">
            <ag-grid-angular
                #agGrid
                id="gridListClient"
                class="ag-theme-blue"
                style="width: auto; height: 400px;"
                [gridOptions]="gridOptions"
                [columnDefs]="columnDefs"
                [defaultColDef]="defaultColDef"
                [components]="components"
                [pagination]="true"
                [rowData]="rowData"
                [suppressMultiSort]="true"
            ></ag-grid-angular>
        </div>
    </div>
</section>
